import { ContentViewModel } from '@levelapp/softfabric';
export default class ButtonImportFileWebViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        // State init
        this.initialState({});
        // Bindings
        this.handleClick = this.handleClick.bind(this);
    }
    /* HANDLERS */
    handleClick() {
        this._view.refs.fileUploader.click();
    }
    handleFileChanged(file) {
        this.props().action(file);
    }
}
